export default "__VITE_ASSET__42ab73ad__"